import Dialog from '@pelckmans/elementis/components/dialog';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { ComponentProps, useContext } from 'react';
import ModalContext from '../../../../../contexts/ModalContext';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  fullWidth?: boolean;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  id: string;
  onReload?: () => void;
  'aria-label': string;
}

function MaterialModal({ headerProps, id, children, fullWidth, onReload, 'aria-label': ariaLabel }: Props) {
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  return (
    <Dialog
      id={id}
      modal
      onClose={handleClose}
      size="full"
      aria-label={ariaLabel}
      className={classNames(fullWidth && 'fullwidth-embeddable-media', 'embeddable-media')}
    >
      <MaterialDialogHeader
        title={headerProps.title}
        tags={headerProps.tags}
        onClose={handleClose}
        onReload={onReload}
        titleTooltip={headerProps.titleTooltip}
      />
      <Dialog.Body>{fullWidth ? children : <div className="centered-embeddable-media">{children}</div>}</Dialog.Body>
    </Dialog>
  );
}

export default MaterialModal;
